/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PropostaCloneDTO } from './proposta-clone-dto';
import { MotivoEsclusioneImportazioneEsercente } from './motivo-esclusione-importazione-esercente';
import { NegozioProposta } from './negozio-proposta';


export interface EsercenteImportazionePropostaDTO { 
    pratica_origine_id?: string;
    codice_pratica_origine?: string;
    profilo_esercente_id?: string;
    ragione_sociale?: string;
    partita_iva?: string;
    esclusa_motivo?: MotivoEsclusioneImportazioneEsercente;
    proposta?: PropostaCloneDTO;
    negozi?: Array<NegozioProposta>;
}



